<template>
  <div class="top-info">
    <div class="title">
      {{ $store.getters['program/data'].name }}
      <span class="finished" v-if="$store.getters['program/data'].finished">
        {{$ml.get('finished')}}
      </span>
    </div>
    <table>
      <tr class="head">
        <td>{{ $ml.get('Farm') }} </td>
        <td>{{ $ml.get('Field') }}</td>
        <td>{{ $ml.get('Area, ') }}{{$store.getters['unit/getLabel']('ha')}}</td>
        <td>{{ $ml.get('Planting date') }}</td>
        <td>{{ $ml.get('Crop') }}</td>
        <td>{{ $ml.get('Program type') }}</td>
      </tr>
      <tr>
        <td>{{ ( $store.getters['farms/farms'].find(x => x.id == $store.getters['program/data'].farmId) ).name }}</td>
        <td>{{ ( $store.getters['farms/fields'].find(x => x.id == $store.getters['program/data'].fieldId) ).name }}</td>
        <!-- <td>{{ ( $store.getters['farms/fields'].find(x => x.id == $store.getters['program/data'].fieldId) ).area }}</td> -->
        <td>{{ $store.getters['unit/convert']('ha', ( $store.getters['farms/fields'].find(x => x.id == $store.getters['program/data'].fieldId) ).area) }}</td>
        <td>{{ $store.getters['program/data'].plantingDate }}</td>
        <td>{{ ( $store.getters['user-crops/data'].find(x => x.id == $store.getters['program/data'].baseCropId).name ) }}</td>
        <td>{{ $store.getters['program/data'].type == 'hydroponic' ? $ml.get('Hydroponic') : $ml.get('Soil-based') }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

.top-info {
  width: 100%;
  padding-bottom: 30px;

  .title {
    font-weight: bold;
    font-size: 20px;
    padding: 20px 0;

    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .finished {
    font-size: 12px;
    margin: 0 10px;
    text-transform: uppercase;
    background: $mainGreen;
    color: #fff;
    padding: 3px 5px;
    border-radius: 3px;
    line-height: 1;
    box-shadow: 0 2px 8px rgba(0,0,0,0.2);
  }

  table {
    width: 100%;
    border-spacing: 0;
    border: 1px solid rgba($color: #333, $alpha: 0.1);
    border-radius: 3px;
    td {
      font-weight: bold;
      font-size: 14px;
      padding: 10px 15px;
      border-bottom: 1px solid rgba($color: #333, $alpha: 0.1);
    }
    tr {
      &:last-child {
        td {
          border-bottom: 0;
        }
      }
    }
    .head {
      td {
        font-weight: normal;
        font-size: 12px;
      }
    }
  }
}

</style>
